import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [totalCost, setTotalCost] = useState(3000);
  const [term1, setTerm1] = useState(12);
  const [term2, setTerm2] = useState(18);

  const minDownPayment = 500;
  const calculatedDownPayment = Math.round(Number(totalCost) * 0.35);
  const maxDownPayment = Math.max(minDownPayment, calculatedDownPayment);
  const isSliderDisabled = calculatedDownPayment < minDownPayment;

  const [downPayment1, setDownPayment1] = useState(minDownPayment);
  const [downPayment2, setDownPayment2] = useState(minDownPayment);

  // Clamp down payments when total cost changes
  useEffect(() => {
    const max = Math.max(minDownPayment, Math.round(Number(totalCost) * 0.35));
    setDownPayment1((prev) => Math.min(Math.max(prev, minDownPayment), max));
    setDownPayment2((prev) => Math.min(Math.max(prev, minDownPayment), max));
  }, [totalCost]);

  const monthly1 = term1 ? ((Number(totalCost) - downPayment1) / Number(term1)).toFixed(2) : 0;
  const monthly2 = term2 ? ((Number(totalCost) - downPayment2) / Number(term2)).toFixed(2) : 0;

  return (
    <>
      <div className="header">
        <img src="/flex-ortho-dark-logo-EN.png" alt="Logo" className="logo-img" />
        <h1>Dental Payment Planner</h1>
      </div>

      <div className="container">
        <div className="input-group">
          <label>Total Cost ($)</label>
          <input
            type="number"
            min="0"
            value={totalCost}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '') {
                setTotalCost('');
              } else {
                setTotalCost(Math.max(Number(val), 0));
              }
            }}
          />
        </div>

        <div className="summary-grid">
          {/* Option 1 */}
          <div className="summary-column">
            <h2>Option 1</h2>

            <div className="input-group">
              <label>Months</label>
              <input
                type="number"
                min="1"
                value={term1}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    setTerm1('');
                    setTerm2('');
                  } else {
                    const newTerm1 = Math.max(Number(val), 1);
                    setTerm1(newTerm1);
                    setTerm2(newTerm1 + 6);
                  }
                }}
              />
            </div>

            <div className="input-group">
              <label><strong>Down Payment</strong></label>
              <input
                type="range"
                className="horizontal-slider-input"
                min={minDownPayment}
                max={maxDownPayment}
                step="10"
                value={downPayment1}
                onChange={(e) => setDownPayment1(Number(e.target.value))}
                disabled={isSliderDisabled}
              />
              <div className="result-value">${downPayment1}</div>
              {isSliderDisabled && (
                <p className="warning-text">
                  35% of total cost is less than $500. Minimum down payment required is $500.
                </p>
              )}
            </div>

            <div className="result-block">
              <label>Monthly Payment</label>
              <div className="result-value">${monthly1}</div>
            </div>
          </div>

          {/* Option 2 */}
          <div className="summary-column">
            <h2>Option 2</h2>

            <div className="input-group">
              <label>Months</label>
              <input
                type="number"
                min="1"
                value={term2}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    setTerm2('');
                  } else {
                    setTerm2(Math.max(Number(val), 1));
                  }
                }}
              />
            </div>

            <div className="input-group">
              <label><strong>Down Payment</strong></label>
              <input
                type="range"
                className="horizontal-slider-input"
                min={minDownPayment}
                max={maxDownPayment}
                step="10"
                value={downPayment2}
                onChange={(e) => setDownPayment2(Number(e.target.value))}
                disabled={isSliderDisabled}
              />
              <div className="result-value">${downPayment2}</div>
              {isSliderDisabled && (
                <p className="warning-text">
                  35% of total cost is less than $500. Minimum down payment required is $500.
                </p>
              )}
            </div>

            <div className="result-block">
              <label>Monthly Payment</label>
              <div className="result-value">${monthly2}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
